import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Form } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import { LocalDate } from "js-joda";
import { localDateFromApi } from "../utils/dateTime";
import stringify, { sortObject } from "../utils/stringify";
import { jsonError } from "../utils/jsonUtils";
import { ExchangeType } from "../constants";

@inject("store")
@observer
class AddSimGroup extends Component {
  state = {
    name: "",
    exchange: ExchangeType.BINANCE,
    type: "BRUTUS",
    fromDate: "",
    toDate: LocalDate.now()
      .plusDays(1)
      .toString(),
    period: 30,
    enabled: true,
    config: "{}",
    configJsonError: undefined,
    configCombinator: "{}",
    configCombinatorJsonError: undefined,
  };

  element = undefined;

  componentDidMount() {
    const { base } = this.props;
    if (base) {
      const { name, exchange, type, fromDate, toDate, period, enabled, config, configCombinator } = base;
      this.setState({
        name: name ? "* " + name : name,
        exchange,
        type,
        fromDate: fromDate ? localDateFromApi(fromDate).toString() : "",
        toDate: toDate ? localDateFromApi(toDate).toString() : "",
        period,
        enabled,
        config: stringify(sortObject(JSON.parse(config), null, 2)),
        configCombinator: stringify(sortObject(JSON.parse(configCombinator))),
      });
    }
    this.element.scrollIntoView();
  }

  submit = async () => {
    const {
      name,
      exchange,
      type,
      fromDate,
      toDate,
      period,
      enabled,
      config,
      configJsonError,
      configCombinator,
      configCombinatorJsonError,
    } = this.state;
    const { botId } = this.props;

    if (configJsonError) {
      alert("Config is not valid JSON:\n" + configJsonError);
      return;
    }

    if (configCombinatorJsonError) {
      alert("Config Combinator is not valid JSON:\n" + configCombinatorJsonError);
      return;
    }

    let axiosRequest = axios.create({
      baseURL: "api",
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      if (botId) {
        await axiosRequest.post("sim/group/runBot", {
          botId,
          configCombinator,
        });
      } else {
        await axiosRequest.post("sim/group/add", {
          name,
          exchange,
          type,
          period,
          fromDate,
          toDate,
          enabled,
          config,
          configCombinator,
        });
      }

      this.props.onSuccess();
    } catch (e) {
      alert(e);
    }
  };

  render() {
    const { botId } = this.props;
    const { configJsonError, configCombinatorJsonError } = this.state;

    return (
      <div ref={e => (this.element = e)}>
        <Form
          style={{
            margin: "10px",
          }}
          onSubmit={this.submit}
        >
          {!botId && <h3>New Sim Group</h3>}
          {!botId && (
            <Form.Group inline>
              <Form.Field>
                <label>Name</label>
                <input
                  value={this.state.name}
                  type="text"
                  size={20}
                  onChange={e => this.setState({ name: e.target.value })}
                />
              </Form.Field>
              <Form.Field>
                <label>Exchange</label>
                <select
                  required
                  value={this.state.exchange}
                  onChange={e => this.setState({ exchange: e.target.value })}
                >
                  {Object.values(ExchangeType).map(exchangeType => (
                    <option key={exchangeType} value={exchangeType}>{exchangeType}</option>
                  ))}
                </select>
              </Form.Field>
              <Form.Field>
                <label>Type</label>
                <select required value={this.state.type} onChange={e => this.setState({ type: e.target.value })}>
                  <option value="BRUTUS">Brutus</option>
                </select>
              </Form.Field>
              <Form.Field>
                <label>Date Range</label>
                <input
                  value={this.state.fromDate}
                  type="date"
                  required
                  onChange={e => this.setState({ fromDate: e.target.value })}
                />
                -
                <input
                  value={this.state.toDate}
                  type="date"
                  required
                  onChange={e => this.setState({ toDate: e.target.value })}
                />
              </Form.Field>
              <Form.Field>
                <label>Period</label>
                <input
                  value={this.state.period}
                  type="number"
                  required
                  onChange={e => this.setState({ period: e.target.value })}
                />
              </Form.Field>
            </Form.Group>
          )}
          {!botId && (
            <Form.Field>
              <label>Base Config</label>
              <textarea
                required
                value={this.state.config}
                onChange={({ target: { value } }) =>
                  this.setState({ config: value, configJsonError: jsonError(value) })
                }
                rows={25}
                style={{
                  fontFamily: "monospace",
                  color: configJsonError ? "red" : undefined,
                }}
              />
              {configJsonError && configJsonError.toString()}
            </Form.Field>
          )}
          <Form.Field>
            <label>Config Combinator</label>
            <textarea
              required
              value={this.state.configCombinator}
              onChange={({ target: { value } }) =>
                this.setState({ configCombinator: value, configCombinatorJsonError: jsonError(value) })
              }
              rows={12}
              style={{
                fontFamily: "monospace",
                color: configCombinatorJsonError ? "red" : undefined,
              }}
            />
            {configCombinatorJsonError && configCombinatorJsonError.toString()}
          </Form.Field>

          <Button primary icon="checkmark" content="Submit" type="submit" />
          {this.props.onClose && <Button icon="close" content="Close" onClick={this.props.onClose} />}
        </Form>
      </div>
    );
  }
}

export default AddSimGroup;



// WEBPACK FOOTER //
// ./src/sim/AddSimGroup.js